export default __webpack_public_path__ + "react/static/phone-req-step-thumb-8bb103d7107bf5970edf25a1f4a7a8ca.png";